import React from "react";
import { IHowItWorksHeroOptions } from "./HowItWorksPage.types";
import { useMedia } from "react-use";
import { BREAKPOINTS } from "layout";
import { MobileHeroSimple } from "pages/Sections/GettingStartedWithUniFi/_components/MobileHeroSimple/MobileHeroSimple";
import { DesktopHeroSimple } from "pages/Sections/GettingStartedWithUniFi/_components/DesktopHeroSimple/DesktopHeroSimple";
import { MobileHero } from "pages/Sections/GettingStartedWithUniFi/_components/MobileHero/MobileHero";
import { DesktopHero } from "pages/Sections/GettingStartedWithUniFi/_components/DesktopHero/DesktopHero";

export const HeroComponent = ({
  hero,
  isInView,
}: Readonly<{ hero: IHowItWorksHeroOptions; isInView: boolean }>) => {
  const isSmallScreen = useMedia(BREAKPOINTS.TABLET_AND_DOWN, false);

  if (hero.isSimpleHero) {
    return isSmallScreen ? (
      <MobileHeroSimple config={hero.mobileConfig} isInView={isInView} />
    ) : (
      <DesktopHeroSimple config={hero.config} isInView={isInView} />
    );
  }

  return isSmallScreen ? (
    <MobileHero config={hero.mobileConfig} />
  ) : (
    <DesktopHero config={hero.config} />
  );
};
